var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tag-group"},_vm._l((_vm.value),function(item,index){return _c('vuestic-tag',{key:index,attrs:{"name":item.name || item,"type":_vm.type || item.type,"removable":_vm.removable,"bundle":item.bundle || false},on:{"remove":function($event){_vm.removeTag(index, item, _vm.uzorak)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-128775a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestic-components/vuestic-tag/VuesticTagGroup.vue
// module id = V5XA
// module chunks = 93